module.exports = __webpack_public_path__ + "img/checkout-right-responsive.d5474cf8.svg";